import api from '~/services/api';

class SalesTrackingService {
  getAllIndicators() {
    return api.get('/custom-indicator/');
  }

  getRecommendation({ userExternalCode, entity, entityExternalCode }) {
    return api.get(
      `/intelligence/sales-potential-group?userExternalCode=${userExternalCode}&entity=${entity}&entityExternalCode=${entityExternalCode}`
    );
  }
}

export default new SalesTrackingService();
